module.exports = __webpack_public_path__ + "static/media/category.15194130.svg";